import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { SUPPORTED_LANGUAGES } from './i18n/config';

Vue.use(VueI18n);

function loadLocaleMessages () {
  const locales = require.context('./i18n/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  })
  return messages;
}

const defaultLang =
  localStorage.getItem('locale') ||
  SUPPORTED_LANGUAGES.find(l => l.default)?.code ||
  'en';

export default new VueI18n({
  locale: defaultLang,
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});
